<template>
  <v-container class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="12" md="11">
        <v-card>
          <v-card-title style="word-break: break-word"> Registration Processed
          </v-card-title>
          <v-img :src="require('../assets/photos/backgrounds/SAM_0042.jpg')" height="200px"></v-img>
          <v-card-subtitle>
            <p>Your registration request has been received.</p>
            <p>You will find a message in your email inbox from
              "info@palmsociety.org.uk", with a link to click to confirm that the address is correct. Once this link is
              clicked, access will be granted. </p>
            <p>If you don't find the message in your inbox, please check your spam
              folder
              before contacting us using the 'Contact' page from the menu above.</p>
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Contact",
  data: () => ({
    rawFile: null
  })
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
